<template>
  <div>
    <BadgeNumber
      v-if="profile.references && profile.references.length"
      :number="profile.references.length"
      :provider="profile.name"
      :profile-url="widgetLink"
      :primary="primary"
      :layout="$route.query.layout || 'regular'"
      :size="$route.query.size || 'regular'"
    />
  </div>
</template>

<script>
import widgetMixin from '~/mixins/widget';
import BadgeNumber from '~/components/Pages/Widgets/Badges/BadgeNumber';

export default {
    components: {
        BadgeNumber
    },
    mixins: [widgetMixin],
    computed: {
        primary() {
            return !!this.$route.query.primary;
        }
    }
};
</script>
